var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"colors-list"},_vm._l((_vm.colors),function([colorName, colorValue]){return _c('li',{key:colorValue,staticClass:"color-box",class:{'active': _vm.activeColor === colorName},style:({backgroundColor: colorValue}),on:{"click":function($event){return _vm.$emit('change', [colorName, colorValue])}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }